import { render, staticRenderFns } from "./PuzzleLoopList.vue?vue&type=template&id=309540ba&"
import script from "./PuzzleLoopList.vue?vue&type=script&lang=js&"
export * from "./PuzzleLoopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports